import { CEBacklogBase } from './ce-backlog-base'


export class CEBacklog extends CEBacklogBase {

}